import { IRowNode, IServerSideSelectionState, RowSelectionOptions, SelectionChangedEvent } from "ag-grid-community";
import { useMemo } from "react";

export const useSelectionOptions = (multi: boolean): RowSelectionOptions => {
  return useMemo(
    () => ({
      mode: multi ? "multiRow" : "singleRow",
      enableMultiSelectWithClick: false,
      enableClickSelection: true,
      copySelectedRows: true,
      headerCheckbox: false,
      checkboxes: false,
    }),
    [multi],
  );
};

// returns true, if the selection has been changed by this handler
export const handleServerSideSelectAllEvent = (event: SelectionChangedEvent): boolean => {
  const serverSideSelectionState = event.api.getServerSideSelectionState() as IServerSideSelectionState | null;
  if (serverSideSelectionState != null && serverSideSelectionState.selectAll) {
    const allNodes: IRowNode[] = [];
    event.api.forEachNode((node) => {
      if (!node.stub && node.data != null) {
        allNodes.push(node);
      }
    });

    event.api.deselectAll("all", event.source); // unset selectAll on server-side data source, then set selected nodes manually
    event.api.setNodesSelected({ nodes: allNodes, newValue: true, source: event.source });
    return true;
  }

  return false;
};
